<template>
<v-card class="fill-height" flat height="auto" fluid>
<v-toolbar>
<v-toolbar-title>
  <v-card-title>Профиль пользователя</v-card-title>
  <v-card-subtitle>Укажите токены доступа к системам ТК, рабочее время и другие параметры системы</v-card-subtitle>
</v-toolbar-title>
<v-spacer/>
<div class="my-3">
    <v-btn block color="primary" x-large  @click="onSaveButtonClick">
        <v-icon large left>mdi-content-save</v-icon> Сохранить
    </v-btn>
</div>
</v-toolbar>
<v-card-text>
  <v-row>
    <v-col sm="12" lg="6" md="12" cols="12" xl="6">
      <v-row>
        <v-col>
            <v-card>
            <v-toolbar>
              <v-toolbar-title>
                <v-card-title>Контактная информация</v-card-title>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              Статус профиля: {{getStatusText(userInfo.isBlocked)}}
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col lg="6" md="12" xl="6" sm="12" cols="12">
                  <v-text-field
                  label="Имя пользователя"
                  v-model="userInfo.fullName"
                  >
                  </v-text-field>
                </v-col>
                <v-col lg="6" md="12" xl="6" sm="12" cols="12">
                  <v-text-field
                    readonly
                    label="Номер договора"
                    v-model="userInfo.contractNumber"
                  ></v-text-field>
                </v-col>
                <v-col lg="6" md="12" xl="6" sm="12" cols="12">
                  <v-text-field
                    readonly
                    label="Логин для входа"
                    v-model="userInfo.login"
                  ></v-text-field>
                </v-col>
                <v-col lg="6" md="12" xl="6" sm="12" cols="12">
                  <v-text-field
                    label="Адрес электронной почты"
                    type="email"
                    v-model="userInfo.email"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card >
          <v-toolbar>
            <v-toolbar-title>
              <v-card-title>Рабочее время</v-card-title>
              <v-card-subtitle>Укажите рабочее время для выявления подозрительных транзакций.</v-card-subtitle>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field type="time"
                  label="Начало"
                  v-model="userInfo.startWorkTime"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field type="time"
                  label="Конец"
                  v-model="userInfo.endWorkTime"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col xl="6" lg="6" md="12" sm="12" cols="12">
      <v-row style="height:100%;">
        <v-col>
          <v-card style="height:100%;">
            <v-toolbar>
              <v-toolbar-title>
                <v-card-title v-card-title>Настройки ТК</v-card-title>
                <v-card-subtitle>Заполните данные параметры для построения отчетов и просмотра рабочего стола.</v-card-subtitle>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text style="height:100%;">
              <v-row>
                <v-col lg="6" md="6" xl="6" sm="6" cols="6">
                  <v-select
                    v-model="cardSystem"
                    :items="cardSystems"
                    label="Система ТК по умолчанию"
                    required
                    ></v-select>
                </v-col>
                <v-col lg="6" md="6" xl="6" sm="6" cols="6">
                  <v-text-field
                    type="tel"
                    required
                    max= 60
                    min= 1
                    label="Погрешность времени (мин.)"
                    v-model="autographTimeInterval"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col lg="12" md="12" xl="12" sm="12" cols="12">
                  <v-card>
                    <v-toolbar>
                      <v-toolbar-title>
                        <v-card-title>Токены доступа</v-card-title>
                        <v-card-subtitle>Укажите токены для автоматизированной вызгрузки данных</v-card-subtitle>
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                      <v-row>
                        <v-col lg="12" md="12" xl="12" sm="12" cols="12"><v-text-field
                      label="Токен доступа ППР"
                      v-model="userInfo.petrolToken"
                      ></v-text-field></v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>

    <!-- <v-form>
      <v-row>
        <v-col lg="6" md="6" xl="6" sm="12" cols="12"><v-text-field
            label="Имя пользователя"
            v-model="userInfo.fullName"
          ></v-text-field></v-col>
          <v-col lg="2" md="2" xl="2" sm="12" cols="12">
            <v-select
              v-model="cardSystem"
              :items="cardSystems"
              label="Система ТК по умолчанию"
              required
              ></v-select>
          </v-col>
          <v-col lg="2" md="2" xl="2" sm="12" cols="12">
            <v-text-field
              type="tel"
              required
              max= 60
              min= 1
              label="Погрешность времени (мин.)"
              v-model="autographTimeInterval"></v-text-field>
          </v-col>
        <v-col lg="2" md="2" xl="2" sm="12" cols="12"><v-text-field
            label="Статус"
            :value="getStatusText(userInfo.isBlocked)" readonly
          ></v-text-field></v-col>
      </v-row>
      <v-row>
        <v-col lg="12" md="12" xl="12" sm="12" cols="12"><v-text-field
            label="Адрес электронной почты"
            type="email"
            v-model="userInfo.email"
          ></v-text-field></v-col>
      </v-row>
      <v-row>
        <v-col lg="5" md="5" xl="5" sm="12" cols="12">
          <v-row>
            <v-col lg="12" md="12" xl="12" sm="12" cols="12"><v-text-field
            readonly
            label="Логин для входа"
            v-model="userInfo.login"
          ></v-text-field></v-col>
          </v-row>
          <v-row>
            <v-col lg="12" md="12" xl="12" sm="12" cols="12">
              <v-card>
                <v-toolbar color="primary" dark dense>
                  <v-card-title>Рабочее время</v-card-title>
                </v-toolbar>
                <v-card-text>
                  <v-row>
                    <v-col><v-text-field type="time"
            label="Начало"
            v-model="userInfo.startWorkTime"
          ></v-text-field></v-col>
                    <v-col><v-text-field type="time"
            label="Конец"
            v-model="userInfo.endWorkTime"
          ></v-text-field></v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col lg="7" md="7" xl="7" sm="12" cols="12">
          <v-card>
                <v-toolbar color="primary" dark dense>
                  <v-card-title>Токены доступа</v-card-title>
                </v-toolbar>
                <v-card-text>
                  <v-row>
                    <v-col lg="12" md="12" xl="12" sm="12" cols="12"><v-text-field
            label="Токен доступа ППР"
            v-model="userInfo.petrolToken"
          ></v-text-field></v-col>
                  </v-row>
                </v-card-text>
              </v-card>
        </v-col>
      </v-row>
    </v-form> -->
</v-card-text>
</v-card>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'UserProfile',
  computed: {
    ...mapState({
      account: state => state.account,
      userInfo: state => state.users.user
    })
  },
  methods: {
    ...mapActions('users', {
      getUserInfo: 'getUserInfo',
      updateUserInfo: 'updateUserInfo'
    }),
    ...mapActions('alert', {
      successAlert: 'success'
    }),
    getStatusText (status) {
      if (status === true) {
        return 'Заблокирован'
      } else {
        return 'Активен'
      }
    },
    onSaveButtonClick () {
      if (this.autographTimeInterval > 0 && this.autographTimeInterval <= 60) {
        this.updateUserInfo(this.userInfo)
        localStorage.setItem('defaultCardSystem', this.cardSystem)
        localStorage.setItem('autographTimeInterval', this.autographTimeInterval)
        this.successAlert('Все данные успешно сохранены')
      } else {
        alert('Недопустимое значение "Погрешность времени", укажите целое число от 1 до 60')
      }
    }
  },
  mounted () {
    this.login = this.userInfo.login
    document.title = 'Профиль пользователя - ATK Web'
    this.getUserInfo(this.account.user.id)
    this.cardSystem = localStorage.getItem('defaultCardSystem') ? localStorage.getItem('defaultCardSystem') : 'ППР'
    this.autographTimeInterval = localStorage.getItem('autographTimeInterval') ? localStorage.getItem('autographTimeInterval') : 15
  },
  data () {
    return {
      login: '',
      cardSystem: 'ППР',
      cardSystems: ['ППР', 'Опти24', 'Shell', 'Neste Oil', 'Роснефть'],
      autographTimeInterval: 15
    }
  }
}
</script>
